import { render, staticRenderFns } from "./ProducttypeSawlineDetailsPage.vue?vue&type=template&id=f5221dd0"
import script from "./ProducttypeSawlineDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProducttypeSawlineDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports